/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Submit_SuccessInputs */

const vi_carrier_form_submit_success = /** @type {(inputs: Carrier_Form_Submit_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã tạo vận đơn`)
};

/**

* @param {Carrier_Form_Submit_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_submit_success = /** @type {((inputs?: Carrier_Form_Submit_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Submit_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_submit_success(inputs)
});